<template>
    <div id="copyrights" class="container">
    	<div class="row">
    		<div class="col-xs-12 text" v-if="hasDetailedAccess">
    			<p v-html="text"></p>
    		</div>

            <div class="col-xs-12" v-else>
                <div class="permission" v-show="!hasPermission">
                    <span class="iconify" data-icon="topcoat:lock" data-inline="false" data-height="100"></span>
                    <br><br>
                    <p style="white-space: initial;">In order to see this information,<br> you have to <u>request</u> access to extended/detailed song metadata.</p>
                    <br>
                    <div class="button btn btn-default" @click="askDataPermission()">Request {{ song.uploader.name }}</div>
                </div>

                <div class="permission" v-show="hasPermission">
                    <span class="iconify" data-icon="uil:file-info-alt" data-inline="false" data-height="90"></span><br><br>
                    <br><p style="white-space: initial;">Your request for <b>metadata information</b><br> has been submited !</p>
                </div>
            </div>
    	</div>
	</div>
</template>

<style type="text/css">
	#copyrights{ min-height: 0px; padding: 30px; text-align: center; min-height: 60vh; }

	#copyrights .text{ margin: 0px 0px 50px 0px; font-size: 16px; text-align: center;}
	#copyrights .text strong{ font-weight: 900; }

	#copyrights h5{ line-height: 45px; }
	#copyrights .row > div { padding: 0px 10px; }
</style> 

<script>
 
export default {
    components: {
        'loader': require('@/components/Loader.vue').default,
    },

    props: ['song'],

    data() {
        return {
        	text: this.song.label_copy,
		    loading: true,
		}
	},

    mounted(){
    },

	methods:{
        askDataPermission(){
            this.$http.post(`${App.restApi}/api/song/${this.song.id}/detailed-access`).then((success) => {
                if (App.allowGtag) gtag('event', `request_stats_access`, {
                    'event_category' : 'song',
                    'event_label' : `Request detailed stats for ${ this.isOwner ? 'own' : 'other user'} song`
                });
            });

            this.$root.$emit('request-access');          
        },        
	},

	computed: {
        hasDetailedAccess(){
            return App.user.id == 211 || (this.song.flags && this.song.flags.users_with_detailed_access && this.song.flags.users_with_detailed_access.indexOf(App.user.id) > -1);
        },

        hasPermission(){
            return this.song.permission;
        },

		isOwner(){
			return App.user.id == this.song.uploader_id;
		},
	}
}
</script>
